import {
	EmailOutlineIcon,
	FacebookIcon,
	FacebookMessengerIcon,
	InstagramIcon,
	LineIcon,
	LinkIcon,
	NextDoorIcon,
	RedditIcon,
	ShareIcon,
	SmsIcon,
	TikTokIcon,
	TwitterIcon,
	VkIcon,
	WhatsAppIcon,
} from '@change/ds-icons';

import type { ShareChannelButtonChannel } from './types';

export const ICON_BY_CHANNEL: Readonly<Record<ShareChannelButtonChannel, React.ReactNode>> = {
	instagramStories: <InstagramIcon />,
	facebook: <FacebookIcon />,
	facebookMessenger: <FacebookMessengerIcon />,
	twitter: <TwitterIcon />,
	whatsapp: <WhatsAppIcon />,
	instagram: <InstagramIcon />,
	vk: <VkIcon />,
	line: <LineIcon />,
	nextdoor: <NextDoorIcon />,
	email: <EmailOutlineIcon />,
	sms: <SmsIcon />,
	copy: <LinkIcon />,
	mobileNativeShare: <ShareIcon />,
	reddit: <RedditIcon />,
	tiktok: <TikTokIcon />,
};
